import React, { useRef, useState } from "react";
import { Helmet } from "react-helmet-async";
import Navbar from "../../components/Navbar/Navbar";
import contactImg from "../../assets/images/contact.jpg";
import Hero from "../../components/Hero/Hero";
import { PacmanLoader } from "react-spinners";
import Footer from "../../components/Footer/Footer";
import classes from "./Contact.module.scss";
import ContactModal from "../../components/Modals/ContactModal";

const Contact = () => {
  const nameRef = useRef(null);
  const emailRef = useRef(null);
  const phoneRef = useRef(null);
  const messageRef = useRef(null);

  const [state, setState] = useState({
    name: "<Required>",
    email: "<Required>",
    phone: "<Not Entered>",
    message: "<Required>",
    sending: false,
    code: "UBG-MOJI",
    dialog: false,
    error: false,
    errorMessage: "",
  });

  const sendEmail = async (e) => {
    e.preventDefault();

    try {
      setState((prevState) => {
        return {
          ...prevState,
          sending: true,
        };
      });

      // submit contact form to API
      let response = await fetch(
        `https://api.ramteentaheri.com:3838/mailer/submit-form`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            code: state.code,
            name: state.name,
            email: state.email,
            phone: state.phone,
            message: state.message,
          }),
        }
      );

      response = await response.json();

      if (!response.success) {
        const error = new Error(
          "There was an issue with the contact form server. please contact the administrator, or try again later!"
        );

        throw error;
      }

      nameRef.current.value = "";
      emailRef.current.value = "";
      phoneRef.current.value = "";
      messageRef.current.value = "";

      setState((prevState) => {
        return {
          ...prevState,
          sending: false,
          name: "",
          email: "",
          phone: "",
          message: "",
          dialog: true,
        };
      });
    } catch (err) {
      setState((prevState) => {
        return {
          ...prevState,
          sending: false,
          error: true,
          errorMessage: err.message,
        };
      });
    }
  };

  const handleOnKeyDown = (e) => {
    if (e.keyCode === 13) {
      setState((prevState) => {
        return {
          ...prevState,
          message: prevState.message + "<br />",
        };
      });
    }
  };

  const handleOnChange = (type, e) => {
    let placeholder = "<Required>";

    if (type === "phone") {
      placeholder = "<Not Entered>";
    }

    setState((prevState) => {
      return {
        ...prevState,
        [type]: e.target.value.length > 0 ? e.target.value : placeholder,
      };
    });
  };

  const handleClose = () => {
    setState((prevState) => {
      return {
        ...prevState,
        dialog: false,
        error: false,
        errorMessage: "",
      };
    });
  };

  return (
    <div className={classes["contact"]}>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Contact | Unified Building Group</title>
      </Helmet>
      <Navbar />
      <Hero title={`Contact us`} image={contactImg} />
      <section className={classes["contact-section"]}>
        {/* <img src="" alt="" /> */}
        <div className={classes["container"]}>
          <ContactModal
            open={state.dialog}
            handleClose={handleClose}
            title="Message Sent!"
            text="We will get back to you as soon as possible. Thank you for your patience."
            buttonText="OK"
          />
          <ContactModal
            open={state.error}
            text={state.errorMessage}
            handleClose={handleClose}
            title="Error"
            buttonText="OK"
          />
          <h2>GET IN TOUCH WITH US</h2>
          <div className={classes["form-container"]}>
            <form className={classes["form-control"]} onSubmit={sendEmail}>
              <input
                type="text"
                placeholder="Name"
                name="user_name"
                onChange={(e) => handleOnChange("name", e)}
                required
                ref={nameRef}
              />
              <input
                type="email"
                placeholder="Email"
                name="user_email"
                onChange={(e) => handleOnChange("email", e)}
                required
                ref={emailRef}
              />
              <input
                type="text"
                placeholder="Phone"
                name="phone"
                onChange={(e) => handleOnChange("phone", e)}
                ref={phoneRef}
              />
              <textarea
                name="message"
                cols={30}
                rows={10}
                placeholder="Type a message..."
                onChange={(e) => handleOnChange("message", e)}
                onKeyDown={(e) => handleOnKeyDown(e)}
                required
                ref={messageRef}
              ></textarea>
              {!state.sending && (
                <button className={classes["send-btn"]} type="submit">
                  Send Message
                </button>
              )}
              {state.sending && (
                <div className={classes["loader"]}>
                  <p>Sending Email</p>
                  <PacmanLoader
                    color="#67066f"
                    size={15}
                    style={{
                      position: "relative",
                      left: "-30px",
                      display: "block",
                    }}
                  />
                </div>
              )}
            </form>
            <div className={classes["contact-details"]}>
              <div className={classes["placeholder"]}>
                Email: &nbsp;
                <a href="mailto:admin@unifiedbg.com.au">
                  Admin@unifiedbg.com.au
                </a>
              </div>
              <div className={classes["placeholder"]}>
                Phone Number: &nbsp;
                <a href="tel:1800824000">1800-UBG-000 (1800 824 000)</a>
              </div>
              <div className={classes["placeholder"]}>
                Address: &nbsp;
                <a
                  href="https://www.google.com/maps/dir//123+Epping+Rd+Macquarie+Park+NSW+2113/@-33.78406,151.1183696,16z/data=!4m5!4m4!1m0!1m2!1m1!1s0x6b12a7a9081591cf:0xcbd40c3940f109de"
                  target="_blank"
                  rel="noreferrer"
                >
                  Avaya House, Level 9, 123 Epping Rd, Macquarie Park, NSW 2113
                </a>
                <iframe
                  title="Get Directions"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3316.0945896658613!2d151.11349869410796!3d-33.78405544571854!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b12a7a9081591cf%3A0xcbd40c3940f109de!2s123%20Epping%20Rd%2C%20Macquarie%20Park%20NSW%202113!5e0!3m2!1sen!2sau!4v1724385879896!5m2!1sen!2sau"
                  width="100%"
                  height="450"
                  style={{ border: 0, marginTop: "1rem" }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Contact;
